import React from 'react';
import './App.scss';
import Header from './components/Header.js';
import About from './components/About.js';
import Skills from './components/Skills.js';
import Contact from './components/Contact.js';
import Projects from './components/Projects.js';
import Certifications from './components/Certifications.js';
import QualificationsSection from './components/Qualifications.js';

function App() {
  return (
    <div className="App">
      <Header />
      <About />
      <Skills />
      <hr className="section-divider light-divider" />
      <QualificationsSection />
      <hr className="section-divider light-divider" />
      <Projects />
      <hr className="section-divider light-divider" />
      <Certifications />
      <Contact />
    </div>
  );
}

export default App;
